import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  sellers: [],
  currentSeller: {
    name: null,
    id: null
  },
  sellerMaps: [],
  volumeDistribution: {
    chartOptions: {
      labels: [],
      series: [],
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'ligth',
          type: 'vertical',
          shadeIntensity: 0.4,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100]
        }
      },
      colors: ['#56e2cf', '#56aee3', '#307fff', '#5668e2', '#cf55e2', '#e356ae', '#e25567', '#e28955', '#e2cf56', '#aee255'],
      legend: {
        show: true,
        formatter: function (val, opts) {
          return val.substring(0, 10) + ' - ' + opts.w.globals.series[opts.seriesIndex]
        },
        position: 'right'
      }
    }
  }
}

const getters = {

}

const actions = {
  getSellers ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {seller_name: filter.sellerName, page_id: filter.pageId, no_map_only: filter.no_map_only}
      })
        .then(response => {
          if (response.data.payload.seller) {
            commit('SET_sellers', response.data.payload.seller)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSellerMapping ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'loadSellerMappings',
        payload: {seller_id: filter.sellerId}
      })
        .then(response => {
          console.log('loadSellerMappings', response.data.payload)
          if (response.data.payload) {
            commit('SET_sellerMapping', response.data.payload.seller_maps)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSaveMapping ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveMapping',
        payload: {
          mapping_id: filter.mappingId,
          text_id: filter.textId,
          seller_id: filter.sellerId
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getCurrentSeller ({ commit }, filter) {
    commit('SET_currentSeller', filter)
  }
}

const mutations = {
  SET_sellers (state, data) {
    state.sellers = data
  },
  SET_currentSeller (state, data) {
    state.currentSeller.name = data.name
    state.currentSeller.id = data.id
  },
  SET_sellerMapping (state, data) {
    state.sellerMaps = data
    state.volumeDistribution.chartOptions.labels = data.map(e => e.seller_text)
    state.volumeDistribution.chartOptions.series = data.map(e => Number(e.text_dist))
  },
  RESET_sellerMapping (state, data) {
    state.sellerMaps = []
    state.volumeDistribution.chartOptions.labels = []
    state.volumeDistribution.chartOptions.series = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/availabilityMapping.js